export default "__VITE_ASSET__PvG7guh$__"